export default "__VITE_ASSET__Dg20xBwd__"